<template>
  <div>
    <template v-if="content || arraydata.length > 0 || htmlcontent">
      <button class="job-detail-list-item" @click="openBottomSheet()">
        {{ name }} <i class="fas fa-arrow-right ml-x1"></i>
      </button>
      <div class="bottom-sheet-container" :class="{ 'bottom-sheet-open' : bottomSheetOpen }">
        <div class="bottom-sheet">
          <div class="d-flex justify-content-between">
            <div class="h4 mb-x2 capitalize">
              {{ name }}
            </div>
            <i class="fas fa-times close-icon" @click="closeBottomSheet()"></i>
          </div>
          <img class="uploaded-image" :src="filePath + 'uploads/files/' + content" v-if="image">
          <div v-else-if="array">
            <ul>
              <li v-for="(item, index) in arraydata" :key="index">{{ item }}</li>
            </ul>
          </div>
          <template v-else-if="html">
            <div v-html="htmlcontent"></div>
          </template>
          <div class="value pre-wrap" v-else>{{ content }}</div>
        </div>
        <div class="click-away" @click="closeBottomSheet()" v-if="bottomSheetOpen"></div>
      </div>
    </template>
  </div>
</template>

<script>
const apiChoice = process.env.VUE_APP_API_URL

export default {
  name: 'BottomSheet',
  props: {
    content: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    image: {
      type: Boolean,
      default: false
    },
    array: {
      type: Boolean,
      default: false
    },
    arraydata: {
      type: Array,
      default: () => []
    },
    html: {
      type: Boolean,
      default: false
    },
    htmlcontent: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      bottomSheetOpen: false,
      filePath: apiChoice
    }
  },
  components: {},
  created () {},
  mounted () {},
  computed: {},
  methods: {
    openBottomSheet () {
      this.bottomSheetOpen = true
      document.body.classList.add('modal-open')
      // this.$emit('open')
    },
    closeBottomSheet () {
      this.bottomSheetOpen = false
      // this.$emit('close')
      document.body.classList.remove('modal-open')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/variables.scss";

.job-detail-list-item{
  display: flex;
  justify-content: space-between;
  background: none;
  border: none;
  border-bottom: solid 2px $color-action;
  width: 100%;
  color: $color-action;
  padding: 12px 12px;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  i{
    font-size: 18px;
  }
}

.bottom-sheet-container{
  width: 100vw;
  height: 100dvh;
  top: 110dvh;
  left: 0px;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow-y: hidden;
  z-index: 920;
  transition: top 250ms;
  &.bottom-sheet-open{
    top: 0px;
  }
}

.bottom-sheet{
  padding: 24px 24px 48px;
  border-radius: 24px 24px 0px 0px;
  background: white;
  width: 100vw;
  max-width: 600px;
  // experiment
  max-height: 85vh;
  min-height: 40vh;
  // height: calc(100vh - 80px);
  // margin-top: 80px;
  overflow-y: auto;
  box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.18);
  z-index: 2;
}

.close-icon{
  font-size: 24px;
  margin-top: 16px;
  cursor: pointer;
}

.uploaded-image{
  width: 100%;
}

ul{
  padding: 0 0px 0px 16px;
  li{
    margin-bottom: 4px;
  }
}
// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .bottom-sheet-container {
    align-items: center;
  }
  .bottom-sheet {
    border-radius: 24px 24px 24px 24px;
  }
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
